import React from "react";

export const SectionHeader = ({ label, title, highlight, center = true, stack = false, className = "" }) => (
  <div className={`${center ? "text-center max-w-3xl mx-auto" : ""} mb-12 ${className}`}>
    {label && <p className="kk-label mb-3" data-testid="section-label">{label}</p>}
    <h2 className="kk-heading text-3xl sm:text-4xl lg:text-5xl leading-tight">
      {title}{highlight && (stack ? <><br /><span className="text-[#BB0000]">{highlight}</span></> : <> <span className="text-[#BB0000]">{highlight}</span></>)}
    </h2>
  </div>
);

export default SectionHeader;
